import { QuestionCategoryAdapterInteface } from 'src/adapter/QuestionCategoryAdapterInterface';
import {
  QuestionCategorySendAttributes,
  QuestionCategoryGetAttributes,
  QuestionCategoryContainQuestionTemplatesAttributes,
} from 'src/models/QuestionCategoryModel';
import { api } from 'boot/axios';
import { axiosErrorHandler } from 'src/error/handler/axiosErrorHandler';
export class AxiosQuestionCategoryAdapter
  implements QuestionCategoryAdapterInteface
{
  async getAllQuestionCategoriesContainQuestionTemplates(): Promise<
    QuestionCategoryContainQuestionTemplatesAttributes[]
  > {
    try {
      const res = await api.get(
        '/question-categories-contain-question-templates'
      );
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async getQuestionCategory(
    id: string
  ): Promise<QuestionCategoryGetAttributes> {
    try {
      const res = await api.get(`/question-categories/${id}`);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async createQuestionCategory(
    attributes: QuestionCategorySendAttributes
  ): Promise<QuestionCategoryGetAttributes> {
    try {
      const res = await api.post('/question-categories', attributes);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async updateQuestionCategory(
    id: string,
    attributes: QuestionCategorySendAttributes
  ): Promise<QuestionCategoryGetAttributes> {
    try {
      const res = await api.put(`/question-categories/${id}`, attributes);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async deleteQuestionCategory(id: string): Promise<boolean> {
    try {
      return await api.delete(`/question-categories/${id}`);
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
}
